<template>
  <div>
    <table class="table table-stripped">
      <tr>
        <th>Project</th>
        <th>Group</th>
        <th></th>
      </tr>
      <tr v-for="project in projects">
        <td>{{ project.project.name }}</td>
        <td>{{ project.project.group_id > -1 ? project.project.group_id : 'PO' }}</td>
        <td>
                  <span v-if="project.project.group_id > -1" class="btn btn-sm btn-success" @click="changeGroupId(project.project, project.project.group_id + 1)">
                    <span>+</span>
                  </span>
          <span v-if="project.project.group_id > -1" class="btn btn-sm btn-danger" @click="changeGroupId(project.project, project.project.group_id - 1)">
                    <span>-</span>
                  </span>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
  export default {
    props: ['projects'],
    methods: {
      changeGroupId(project, group_id) {
        this.axios.post('projects/' + project.id + '/group/change', {group_id}).then(response => {
          project.group_id = response.data.group_id
        }).catch(err => {
          project.group_id = 0
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/financialReports/ProjectGroups.vue